export default __webpack_public_path__ + "static/media/privacy.dad0745f.svg";